import { OLModal } from "components/Tooltips/OLModal";
import { useMessage } from "hooks/intl";
import { RewardCategoryForm } from "./RewardCategoryForm";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AddRewardCategory({ open, onClose }: Props) {
  const { message } = useMessage();

  return (
    <OLModal
      open={open}
      onClose={onClose}
      header={message({ id: "addCategory" })}
      subHeader={message({ id: "rewardCategoryFormDescription" })}
      modalWidth={536}
    >
      <RewardCategoryForm onClose={onClose} />
    </OLModal>
  );
}
